import { max } from 'lib/array/arrayUtils'

// Only the most-booked available room can show low-inventory urgency.
export function getUrgencyRoomCounts(packageOptions: Array<App.OfferPackageOptionView>): Map<string, number> {
  const availablePackageOptions = packageOptions.filter(packageOption => (packageOption.availableRooms || 0) > 0)
  const packageView = max(availablePackageOptions, packageView => packageView.package.roomType?.stats.booked || 0)
  if (packageView?.availableRooms && packageView.package.roomType?.id && packageView.availableRooms > 0 && packageView.availableRooms <= 10) {
    return new Map([[packageView.package.roomType.id, packageView.availableRooms]])
  }
  return new Map()
}
